import React, { useContext, useEffect, useState } from "react";
import "./LoanDetailsMemberView.css";
import InputForm, {
  AutoCompleteValue,
} from "../../../Components/InputForm/InputForm";

import { useLocation, useSearchParams } from "react-router-dom";
import { APICall } from "../../../Helpers/Network/APICalls";
import {
  GetLoanDetailsById,
  GetLoanRepaymentCalculatedAmounts,
  GetLoanRepaymentDetailsById,
  InsertLoanRepaymentDetails,
  ReplaceSurety,
  getSuretyDetailsForApproval,
} from "../../../Helpers/APIEndPoints/EndPoints";
import { ApiStatus } from "../../../Helpers/Enums/ApiStatus";
import { IconButton, Tooltip, Typography } from "@mui/material";
import ButtonComponent from "../../../Components/ButtonForm/Button";
import { Modal } from "react-bootstrap";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import ButtonForm from "../../../Components/ButtonForm/ButtonForm";
import { useNavigate } from "react-router-dom";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import LoanRepaymentVerifyModal from "../LoanRepaymentVerifyModal/LoanRepaymentVerifyModal";
import {
  LoanRepayment,
  LoanStatus,
} from "../../../Helpers/Enums/ApplicationStatus";
import { VerifyModalModules } from "../Enums/VerifyModalModules";

const LoanRepaymentDetails = (props) => {
  const { LoanRequestId, LoanRepaymentId, Status, selectNextTab } = props;
  const context = getContext();
  const navigate = useNavigate();

  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [isFirstVisit, setIsFirstVisit] = useState<boolean>(false);
  // const [RepaymentAmount, setRepaymentAmount] = useState<number>(0);
  // const [TotalRepayAmount, setTotalRepayAmount] = useState<number>(0);
  // const [Balance, setBalance] = useState<number>(0);
  // const [LLRepayAmount, setLLRepayAmount] = useState("");
  // const [LLRepayInt, setLLRepayInt] = useState("");
  // const [ALRepayAmount, setALRepayAmount] = useState("");
  // const [ALRepayInt, setALRepayInt] = useState("");
  // const [ServiceCharges, setServiceCharges] = useState("");
  // const [CGSTAmount, setCGSTAmount] = useState("");
  // const [SGSTAmount, setSGSTAmount] = useState("");
  // const [IGSTAmount, setIGSTAmount] = useState("");
  // const [isChecked, setIsChecked] = useState(false);
  // const [Reason, setReason] = useState("");
  const [isViewMode] = useState<boolean>(
    ![
      0,
      LoanRepayment.LoanRepayment_InternalTeamSendBackLoanRepayment,
      LoanStatus.LoanModule_LoanApplicationApproved,
    ].includes(Status)
  );

  const [data, setData] = useState({
    LoanRequestId: LoanRequestId,
    LoanRepaymentId: LoanRepaymentId,
    RepaymentAmount: 0,
    LLAmount: 0,
    ALAmount: 0,
    LLRepaymentAmount: 0,
    ALRepaymentAmount: 0,
    LLInterestPerc: 0,
    LLInterestAmount: 0,
    ALInterestPerc: 0,
    ALInterestAmount: 0,
    ServiceChargePerc: 0,
    ServiceChargeAmount: 0,
    CGSTPerc: 0,
    CGSTAmount: 0,
    SGSTPerc: 0,
    SGSTAmount: 0,
    IGSTPerc: 0,
    IGSTAmount: 0,
    TotalPayable: 0,
    OutstandingBalance: 0,
    IsLessThanMinimumAmount: 0,
    IsLessThanMinimumAmountReason: "",
    MemberId: context?.MemberId,
    TotalLongTermOutstandingBalance: 0,
    Status: 0,
  });
  const [error, setError] = React.useState<any>({});

  const [isInternalTeam] = useState(
    context?.CurrentRoleId === RoleEnum.InternalTeam
  );
  const [visitCount, setVisitCount] = React.useState(0);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );
  const showLoanRepaymentVerifyModal = Boolean(anchorEl);

  // useEffect(() => {
  //   localStorage.setItem('loanSettlementTabsVisitCount', visitCount.toString());
  
  // }, [visitCount]);

  const resetData = (extraData) => {
    setData({
      ...extraData,
      LLAmount: 0,
      ALAmount: 0,
      LLRepaymentAmount: 0,
      ALRepaymentAmount: 0,
      LLInterestPerc: 0,
      LLInterestAmount: 0,
      ALInterestPerc: 0,
      ALInterestAmount: 0,
      ServiceChargePerc: 0,
      ServiceChargeAmount: 0,
      CGSTPerc: 0,
      CGSTAmount: 0,
      SGSTPerc: 0,
      SGSTAmount: 0,
      IGSTPerc: 0,
      IGSTAmount: 0,
      TotalPayable: 0,
      OutstandingBalance: 0,
    });
  };

  const onClickFunction = async (action: any) => {
    // showLoader();
    
    if (action === "Submit") {
      SubmitLoanRepaymentRequest();
    } else if (action === "Cancel") {
      navigate(-1);
      const storedVisitCount = localStorage.getItem(
        "loanSettlementTabsVisitCount"
      );
      const newVisitCount = parseInt("0");
      setVisitCount(newVisitCount);
      localStorage.setItem(
        "loanSettlementTabsVisitCount",
        newVisitCount.toString()
      );

   
    } else if (action === "Calculate") {
      GetLoanRepaymentCalculatedAmount();
    }
    if (action === "Approve") {
    
      const storedVisitCount = localStorage.getItem(
        "loanSettlementTabsVisitCount"
      );
      const newVisitCount = (parseInt(storedVisitCount, 10) || 0) + 1;
      setVisitCount(newVisitCount);
      localStorage.setItem(
        "loanSettlementTabsVisitCount",
        newVisitCount.toString()
      );

      navigate("/LoanSettlementDashboard");
    }

    // else{
    //   setVisitCount(0);
    //   localStorage.setItem('loanSettlementTabsVisitCount', visitCount.toString());

    // }

    // hideLoader();
  };
  const handleCheckboxChange = () => {
    //setIsChecked(!isChecked);
    setData({
      ...data,
      IsLessThanMinimumAmount: data?.IsLessThanMinimumAmount === 1 ? 0 : 1,
    });

    setError({ ...error, IsLessThanMinimumAmount: null });
  };

  const handleTextEvent = async (event: any, field: any) => {
    let value = event.target.value;
    
    const regex = /^[0-9]+(\.\d{1,2})?$/;
    if (field === "RepayAmount") {
      if (value === "" || regex.test(value)) {
        const isLessThan25perc =
          value < (data.TotalLongTermOutstandingBalance * 25) / 100;
        resetData({
          ...data,
          RepaymentAmount: value,
          IsLessThanMinimumAmount: isLessThan25perc ? 1 : 0,
          TotalLongTermOutstandingBalance: data.TotalLongTermOutstandingBalance,
        });

        setError({
          ...error,
          IsLessThanMinimumAmount: null,
          RepaymentAmount: null,
        });
      }
    }
    if (field === "TotalRepayAmount") {
      // if (value === "" || regex.test(parseFloat(value))) {
      if (value.length > 5) {
        value = value.slice(0, 5);
      }
      if (value <= 100) {
        //setTotalRepayAmount(value);
      }
      setData({ ...data, TotalPayable: value });
      // }
    }
    if (field === "BalanceAmount") {
      // if (value === "" || regex.test(parseFloat(value))) {
      if (value.length > 5) {
        value = value.slice(0, 5);
      }
      if (value <= 100) {
        //setBalance(value);
      }
      setData({ ...data, OutstandingBalance: value });
      // }
    }
    if (field === "reason") {
      setData({
        ...data,
        IsLessThanMinimumAmountReason: value,
      });
      setError({ ...error, IsLessThanMinimumAmountReason: null });
    }
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const GetLoanRepaymentCalculatedAmount = async () => {
    try {
      const isLessThan25perc =
        data.RepaymentAmount <
        (data.TotalLongTermOutstandingBalance * 25) / 100;
      let errorObj = {};
      if (!isLessThan25perc && data.IsLessThanMinimumAmount == 1) {
        errorObj = {
          ...errorObj,
          IsLessThanMinimumAmount:
            "As the Repayment Amount is greater than the 25% of you Outstanding amount, Please uncheck the checkbox.",
        };
      }
      if (isLessThan25perc && data.IsLessThanMinimumAmount != 1) {
        errorObj = {
          ...errorObj,
          IsLessThanMinimumAmount:
            "As the Repayment Amount is less than the 25% of you Outstanding amount, Please check the checkbox.",
        };
      }
      if (
        isLessThan25perc &&
        data.IsLessThanMinimumAmount == 1 &&
        !data.IsLessThanMinimumAmountReason
      ) {
        errorObj = {
          ...errorObj,
          IsLessThanMinimumAmountReason: "This field is required",
        };
      }
      if (data.RepaymentAmount > data?.TotalLongTermOutstandingBalance) {
        errorObj = {
          ...errorObj,
          RepaymentAmount:
            "Repayment Amount should be less than Outstanding Loan",
        };
      }
      if (Object.keys(errorObj).length === 0) {
        errorObj = {
          ...errorObj,
          IsLessThanMinimumAmount: null,
          IsLessThanMinimumAmountReason: null,
          RepaymentAmount: null,
        };
        showLoader();
        const requestData = {
          LoanRequestId: LoanRequestId,
          RepaymentAmount: data.RepaymentAmount,
          MemberId: context?.MemberId,
        };
        
        const resp = await APICall(
          GetLoanRepaymentCalculatedAmounts,
          requestData
        );

        if (resp.Status === ApiStatus.OK && resp.Data) {
          const respData = resp.Data;

          const isLessThan25perc = !isFirstVisit
            ? 0
            : respData?.TotalLongTermOutstandingBalance
              ? data.RepaymentAmount <
                (respData?.TotalLongTermOutstandingBalance * 25) / 100
                ? 1
                : 0
              : 0;

          setData({
            ...data,
            RepaymentAmount: !isFirstVisit
              ? respData?.TotalLongTermOutstandingBalance || 0
              : data?.RepaymentAmount,
            LLAmount: respData?.V_LongTermLoanAmount || 0,
            ALAmount: respData?.V_AdditionalLongTermLoanAmount || 0,
            LLRepaymentAmount: respData?.V_LLRepaymentAmount || 0,
            ALRepaymentAmount: respData?.V_ALRepaymentAmount || 0,
            LLInterestPerc: respData?.V_LLBifurcationPercentage || 0,
            LLInterestAmount: respData?.V_LLInterestAmount || 0,
            ALInterestPerc: respData?.V_ALBifurcationPercentage || 0,
            ALInterestAmount: respData?.V_ALInterestAmount || 0,
            ServiceChargePerc: respData?.V_ServiceChargeAmount || 0,
            ServiceChargeAmount: respData?.V_ServiceChargeAmountDecimal || 0,
            CGSTPerc: respData?.V_ConfigCGSTPercentage || 0,
            CGSTAmount: respData?.V_CGSTAmount || 0,
            SGSTPerc: respData?.V_ConfigSGSTPercentage || 0,
            SGSTAmount: respData?.V_SGSTAmount || 0,
            IGSTPerc: respData?.V_ConfigIGSTPercentage || 0,
            IGSTAmount: respData?.V_IGSTAmount || 0,
            TotalPayable: respData?.TotalPayable || 0,
            OutstandingBalance:
              respData?.OutstadingBalanceAfterTotalPayable || 0,
            TotalLongTermOutstandingBalance:
              respData?.TotalLongTermOutstandingBalance || 0,
            Status: (respData?.StatusID as LoanRepayment) || 0,
            IsLessThanMinimumAmount: isLessThan25perc,
          });
          if (!isFirstVisit) {
            setIsFirstVisit(true);
          }

          //setTotalRepayAmount(respData?.TotalPayable > -1 ? respData?.TotalPayable : "");
          //setBalance(respData?.OutstadingBalanceAfterTotalPayable > -1 ? respData?.OutstadingBalanceAfterTotalPayable : "");
        } else {
          notify(ToastType.Error, "Failed to fetch data.");
        }
      }

      setError(errorObj);
    } catch (err) {
      console.error(err);
    } finally {
      hideLoader();
    }
  };

  const SubmitLoanRepaymentRequest = async () => {
    try {
      showLoader();
      if (!data.TotalPayable) {
        notify(
          ToastType.Error,
          "Please click on calculate to submit the repayment request."
        );
        return;
      }

      let errorObj = {};
      if (
        data.IsLessThanMinimumAmount === 1 &&
        !data.IsLessThanMinimumAmountReason
      ) {
        errorObj = {
          ...errorObj,
          IsLessThanMinimumAmountReason: "This field is required",
        };
      }
      const isLessThan25perc = data?.TotalLongTermOutstandingBalance
        ? data.RepaymentAmount <
          (data?.TotalLongTermOutstandingBalance * 25) / 100
          ? 1
          : 0
        : 0;

      if (!isLessThan25perc && data.IsLessThanMinimumAmount == 1) {
        errorObj = {
          ...errorObj,
          IsLessThanMinimumAmount:
            "As the Repayment Amount is greater than the 25% of you Outstanding amount, Please uncheck the checkbox.",
        };
      }

      if (isLessThan25perc) {
        if (data.IsLessThanMinimumAmount != 1) {
          errorObj = {
            ...errorObj,
            IsLessThanMinimumAmount:
              "As Repayment Amount is 25% less than Outstanding Loan, please check the checkbox.",
          };
        }
      }

      if (data.RepaymentAmount > data?.TotalLongTermOutstandingBalance) {
        errorObj = {
          ...errorObj,
          RepaymentAmount:
            "Repayment Amount should be less than Outstanding Loan",
        };
      }
     
      if (Object.keys(errorObj).length === 0) {
        const requestData = {
          LoanRequestId: data.LoanRequestId,
          LoanRepaymentId: data.LoanRepaymentId,
          RepaymentAmount: data.RepaymentAmount,
          LLAmount: data.LLRepaymentAmount,
          ALAmount: data.ALRepaymentAmount,
          LLInterestPerc: data.LLInterestPerc,
          LLInterestAmount: data.LLInterestAmount,
          ALInterestPerc: data.ALInterestPerc,
          ALInterestAmount: data.ALInterestAmount,
          ServiceChargePerc: data.ServiceChargePerc,
          ServiceChargeAmount: data.ServiceChargeAmount,
          CGSTPerc: data.CGSTPerc,
          CGSTAmount: data.CGSTAmount,
          SGSTPerc: data.SGSTPerc,
          SGSTAmount: data.SGSTAmount,
          IGSTPerc: data.IGSTPerc,
          IGSTAmount: data.IGSTAmount,
          TotalPayable: data.TotalPayable,
          OutstandingBalance: data.OutstandingBalance,
          IsLessThanMinimumAmount: data.IsLessThanMinimumAmount,
          IsLessThanMinimumAmountReason: data.IsLessThanMinimumAmountReason,
          MemberId: data.MemberId,
        };

        const resp = await APICall(InsertLoanRepaymentDetails, requestData);

        if (resp.Status === ApiStatus.OK && resp.Data) {
          notify(
            ToastType.Success,
            "Loan repayment request submitted successfully."
          );
          navigate(-1);
        } else {
          notify(
            ToastType.Error,
            "Loan repayment request submittion failed. Please Contact Administrator"
          );
        }
      }
      setError(errorObj);
    } finally {
      hideLoader();
    }
  };

  const GetLoanRepaymentDetails = async () => {
    try {
      showLoader();
      const requestData = {
        LoanRepaymentId: LoanRepaymentId,
      };

      const resp = await APICall(GetLoanRepaymentDetailsById, requestData);
      
      if (resp.Status === ApiStatus.OK && resp.Data) {
        const respData = resp.Data;

        setData({
          ...data,
          RepaymentAmount: respData?.RepaymentAmount || 0,
          LLAmount: respData?.LLAmount || 0,
          ALAmount: respData?.ALAmount || 0,
          LLRepaymentAmount: respData?.LLAmount || 0,
          ALRepaymentAmount: respData?.ALAmount || 0,
          LLInterestPerc: respData?.LLInterestPerc || 0,
          LLInterestAmount: respData?.LLInterestAmount || 0,
          ALInterestPerc: respData?.ALInterestPerc || 0,
          ALInterestAmount: respData?.ALInterestAmount || 0,
          ServiceChargePerc: respData?.ServiceChargePerc || 0,
          ServiceChargeAmount: respData?.ServiceChargeAmount || 0,
          CGSTPerc: respData?.CGSTPerc || 0,
          CGSTAmount: respData?.CGSTAmount || 0,
          SGSTPerc: respData?.SGSTPerc || 0,
          SGSTAmount: respData?.SGSTAmount || 0,
          IGSTPerc: respData?.IGSTPerc || 0,
          IGSTAmount: respData?.IGSTAmount || 0,
          TotalPayable: respData?.TotalPayable || 0,
          OutstandingBalance: respData?.OutstandingBalance || 0,
          TotalLongTermOutstandingBalance: respData?.TotalLongTermOutstandingBalance || 0,
        });
        if (!isFirstVisit) {
          setIsFirstVisit(true);
        }
      } else {
        notify(ToastType.Error, "Failed to fetch data.");
      }
    } catch (err) {
      console.error(err);
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    if (LoanRepaymentId) {
      GetLoanRepaymentDetails();
    } else {
      GetLoanRepaymentCalculatedAmount();
    }
  }, []);

  useEffect(() => {
    if (data.IsLessThanMinimumAmount == 0) {
      setData({ ...data, IsLessThanMinimumAmountReason: "" });
    }
  }, [data.IsLessThanMinimumAmount]);

  return (
    <div>
      <div className="">
        <div className="col-12">
          <div className="row">
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="form-group"></div>
              <label>Repayment Amount</label>
            </div>
            <div className="col-lg-4 col-md-8 col-sm-12">
              <InputForm
                placeholder={""}
                value={data.RepaymentAmount}
                maxLength={30}
                isDisabled={isViewMode}
                onChange={(e) => handleTextEvent(e, "RepayAmount")}
                textArea={false}
              />{error["RepaymentAmount"] ? (
                <p style={{ color: "red" }}>
                  {error["RepaymentAmount"]}
                </p>
              ) : null}
              <div
                className={`note-text ${isViewMode ? "d-none" : ""}`}
              >{`Note: For partial payment, kindly edit the amount in the repayment amount field. If you want to pay less than 25% of your Outstanding amount, then please check the checkbox`}</div>
            </div>
            {isViewMode ? null : (
              <>
                <div className="col-lg-6 col-md-6 col-sm-12 ">
                  <ButtonComponent
                    className="btn btn-dark"
                    style={{
                      cursor: "pointer",
                    }}
                    icon={""}
                    value={"Calculate"}
                    onClick={() => {
                      onClickFunction("Calculate");
                    }}
                  />
                </div>
                <div className="col-lg-2 col-md-4 col-sm-0"></div>
                <div className="col-lg-8 col-md-8 col-sm-12 m-3">
                  <input
                    autoComplete={AutoCompleteValue}
                    type="checkbox"
                    checked={data.IsLessThanMinimumAmount === 1}
                    onChange={handleCheckboxChange}
                  />
                  <span>
                    {" "}
                    (I want to apply for amount lesser than minimum amount)
                  </span>
                  {error["IsLessThanMinimumAmount"] ? (
                    <p style={{ color: "red" }}>
                      {error["IsLessThanMinimumAmount"]}
                    </p>
                  ) : null}
                </div>
              </>
            )}
          </div>

          {data.IsLessThanMinimumAmount === 1 ? (
            <div className="row mb-2">
              <div className="col-lg-2 col-md-6 col-sm-12">
                <div className="form-group"></div>
                <label>Reason</label>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <InputForm
                  placeholder={""}
                  value={data.IsLessThanMinimumAmountReason}
                  onChange={(e) => handleTextEvent(e, "reason")}
                  textArea={true}
                />
                {error["IsLessThanMinimumAmountReason"] ? (
                  <p style={{ color: "red" }}>
                    {error["IsLessThanMinimumAmountReason"]}
                  </p>
                ) : null}
              </div>
            </div>
          ) : null}

          {isInternalTeam ? (
            <>
              <div className="row mt-2">
                <div className="col-lg-2 col-md-6 col-sm-12">
                  <div className="form-group"></div>
                  <label>LL Repayment Amount</label>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-2">
                  <InputForm
                    placeholder={""}
                    isDisabled={true}
                    value={
                      data.LLRepaymentAmount || data.LLRepaymentAmount == 0
                        ? data.LLRepaymentAmount
                        : ""
                    }
                    maxLength={30}
                    textArea={false}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-2 col-md-6 col-sm-12">
                  <div className="form-group"></div>
                  <label>LL Repayment int</label>
                </div>
                <div className="col-lg-4 col-md-8 col-sm-12">
                  <InputForm
                    placeholder={""}
                    value={
                      data.LLInterestAmount || data.LLInterestAmount == 0
                        ? data.LLInterestAmount
                        : ""
                    }
                    isDisabled={true}
                    maxLength={30}
                    textArea={false}
                  />
                </div>
              </div>

              <div className="row mt-5">
                <div className="col-lg-2 col-md-6 col-sm-12">
                  <div className="form-group"></div>
                  <label>AL Repayment Amount</label>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <InputForm
                    placeholder={""}
                    value={
                      data.ALRepaymentAmount || data.ALRepaymentAmount == 0
                        ? data.ALRepaymentAmount
                        : ""
                    }
                    isDisabled={true}
                    textArea={false}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-2 col-md-6 col-sm-12">
                  <div className="form-group"></div>
                  <label>AL Repayment int</label>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <InputForm
                    placeholder={""}
                    value={
                      data.ALInterestAmount || data.ALInterestAmount == 0
                        ? data.ALInterestAmount
                        : ""
                    }
                    isDisabled={true}
                    textArea={false}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-lg-2 col-md-6 col-sm-12">
                  <div className="form-group"></div>
                  <label>Service Charge</label>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <InputForm
                    placeholder={""}
                    value={
                      data.ServiceChargeAmount || data.ServiceChargeAmount == 0
                        ? data.ServiceChargeAmount
                        : ""
                    }
                    isDisabled={true}
                    textArea={false}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-lg-2 col-md-6 col-sm-12">
                  <div className="form-group"></div>
                  <label>CGST</label>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <InputForm
                    placeholder={""}
                    value={
                      data.CGSTAmount || data.CGSTAmount == 0
                        ? data.CGSTAmount
                        : ""
                    }
                    isDisabled={true}
                    textArea={false}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-lg-2 col-md-6 col-sm-12">
                  <div className="form-group"></div>
                  <label>SGST</label>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <InputForm
                    placeholder={""}
                    value={
                      data.SGSTAmount || data.SGSTAmount == 0
                        ? data.SGSTAmount
                        : ""
                    }
                    isDisabled={true}
                    textArea={false}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-lg-2 col-md-6 col-sm-12">
                  <div className="form-group"></div>
                  <label>IGST</label>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <InputForm
                    placeholder={""}
                    value={
                      data.IGSTAmount || data.IGSTAmount == 0
                        ? data.IGSTAmount
                        : ""
                    }
                    isDisabled={true}
                    textArea={false}
                  />
                </div>
              </div>
            </>
          ) : null}

          <div className="row">
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="form-group"></div>
              <label>Total Payable</label>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <InputForm
                placeholder={""}
                value={`${data.TotalPayable || data.TotalPayable == 0
                    ? data.TotalPayable
                    : ""
                  }`}
                isDisabled={true}
                onChange={(e) => handleTextEvent(e, "TotalRepayAmount")}
                textArea={false}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-lg-2 col-md-6 col-sm-12">
              <div className="form-group"></div>
              <label>Outstanding Balance</label>
            </div>
            <div className="col-lg-4 col-md-6 col-sm-12">
              <InputForm
                placeholder={""}
                value={`${data.OutstandingBalance || data.OutstandingBalance == 0
                    ? data.OutstandingBalance
                    : ""
                  }`}
                isDisabled={true}
                onChange={(e) => handleTextEvent(e, "BalanceAmount")}
                textArea={false}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="d-flex justify-content-end mt-3"
        style={{ marginRight: "2rem" }}
      >
        {context?.CurrentRoleId === RoleEnum.InternalTeam &&
          Status ===
          LoanRepayment.LoanRepayment_MemberApplyForLoanRepayment && (
            <div>
              <ButtonForm
                className="btn btn-submit"
                style={{ marginLeft: 5 }}
                id="Verify"
                value="Verify"
                onClick={(e) => setAnchorEl(e.currentTarget)}
              />
            </div>
          )}
        {context?.CurrentRoleId === RoleEnum.Member &&
          Status < LoanRepayment.LoanRepayment_MemberPaymentDetailsPending && (
            <div>
              <ButtonForm
                className="btn btn-submit"
                style={{ marginLeft: 5 }}
                id="submit"
                value="Submit"
                onClick={() => onClickFunction("Submit")}
              />
            </div>
          )}
        {Status >= LoanRepayment.LoanRepayment_MemberPaymentDetailsPending && (
          <div>
            <ButtonForm
              className="btn btn-submit"
              style={{ marginLeft: 5 }}
              id="next"
              value="Next"
              onClick={() => selectNextTab()}
            />
          </div>
        )}

        <div>
          <ButtonForm
            className="btn btn-cancel"
            id="cancel"
            style={{ marginLeft: 5 }}
            value="Cancel"
            onClick={() => onClickFunction("Cancel")}
          />
        </div>
      </div>

      <LoanRepaymentVerifyModal
        open={showLoanRepaymentVerifyModal}
        anchorEl={anchorEl}
        handleClose={handleClose}
        LoanRepaymentId={LoanRepaymentId}
        module={VerifyModalModules.RepaymentDetails}
      />
    </div>
  );
};

export default LoanRepaymentDetails;
